exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.mdl-mini-footer--link-list li,\n.mdl-mini-footer__link-list li {\n  line-height: 28px;\n}\n\n.prominent a {\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.prominent a:hover {\n  color: #0080af;\n}\n\n", ""]);

// exports
